import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import UserSubmissions from '../components/UserSubmissions';
import LoadingSpinner from '../components/LoadingSpinner';
import {SimpleSection} from '../components/Section';

const SubmissionsPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <LoadingSpinner message="Loading your submissions..." />;
  }

  if (!isAuthenticated) {
    return (
      <Container className="my-4">
        <Row>
          <Col>
            <Alert variant="warning">
              <Alert.Heading>Authentication Required</Alert.Heading>
              <p>
                You need to be logged in to view your submissions. Please go to the{' '}
                <Alert.Link onClick={() => navigate('/user')}>
                  user page
                </Alert.Link>{' '}
                to sign in or register.
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <SimpleSection>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>Your Submissions</h1>
          <Button 
            variant="primary" 
            onClick={() => navigate('/user/submit')}
          >
            Submit New Solution
          </Button>
        </div>
      </SimpleSection>
      <SimpleSection>
        <UserSubmissions />
      </SimpleSection>
    </>
  );
};

export default SubmissionsPage;
